import "./styles/extra.css";
import "./styles/theme.css";
// import "bootstrap-italia/dist/css/bootstrap-italia.min.css";
import "typeface-lora";
import "typeface-roboto-mono";
import "typeface-titillium-web";
import "./index.css";

import {
  AuthContext,
  DataProviderContext,
  TranslationProvider,
} from "react-admin";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { API_CONFIG, API_URL, CASA_DI_VETRO_API_URL } from "./config";

import { createHashHistory } from "history";
import polyglotI18nProvider from "ra-i18n-polyglot";
import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import withContext from "recompose/withContext";
import authProvider from "./authProvider";
import Layout from "./components/Layout";
import Loader from "./components/Loader";
import createAdminStore from "./createAdminStore";
import dataProvider from "./dataProvider";
import messages from "./i18n";
import ContactPage from "./pages/contact";
import ErrorPage from "./pages/error";
import FeedbackPage from "./pages/feedback";
import HelpPage from "./pages/help";
import HomePage from "./pages/home";
import { NodePageProvider } from "./pages/node/NodePageContext";
import NodePageWrapper from "./pages/node/NodePageWrapper";
import PrivacyPolicyPage from "./pages/privacy-policy";
import SearchPage from "./pages/search";
import StickyNodesPage from "./pages/sticky-nodes";
import TagPage from "./pages/tag";
import usePage from "./pages/utils/usePage";

const dp = dataProvider(
  {
    base: API_URL,
    casaDiVetro: CASA_DI_VETRO_API_URL,
  },
  API_CONFIG,
);
const history = createHashHistory();

const SettingsWrapper = () => {
  const [i18nProvider, setI18nProvider] = useState(false);
  const { settings } = usePage("home", {}, false);

  useEffect(() => {
    if (settings) {
      let data = { ...messages.it, ...settings };
      setI18nProvider(
        polyglotI18nProvider((locale) => {
          return data;
        }),
      );
    }
  }, [settings]);

  return i18nProvider ? (
    <TranslationProvider locale="en" i18nProvider={i18nProvider}>
      <BrowserRouter>
        <NodePageProvider>
          <Layout>
            <Switch>
              <Route path="/node" component={NodePageWrapper} />
              <Route path="/nodo" component={NodePageWrapper} />
              <Route path="/sticky-nodes" component={StickyNodesPage} />
              <Route path="/tag/:tag" component={TagPage} />
              <Route
                path="/contenuti-in-evidenza"
                component={StickyNodesPage}
              />

              <Route path="/search" component={SearchPage} />
              <Route path="/cerca" component={SearchPage} />

              <Route path="/contact-us" component={ContactPage} />
              <Route path="/contattaci" component={ContactPage} />

              <Route path="/civic-contact" component={ContactPage} />
              <Route path="/accesso-civico" component={ContactPage} />

              <Route path="/privacy-policy" component={PrivacyPolicyPage} />
              <Route path="/error403" component={ErrorPage} />
              <Route path="/error404" component={ErrorPage} />
              <Route path="/meccanismo-feedback" component={FeedbackPage} />

              <Route path="/help" component={HelpPage} />
              <Route exact path="/" component={HomePage} />
              <Route path="*" component={Error} />
            </Switch>
          </Layout>
        </NodePageProvider>
      </BrowserRouter>
    </TranslationProvider>
  ) : (
    <Loader />
  );
};

const useDecorativeSvgIcons = () => {
  useEffect(() => {
    const mark = (root = document) => {
      root.querySelectorAll("svg.icon").forEach((svg) => {
        if (
          svg.hasAttribute("aria-label") ||
          svg.hasAttribute("aria-labelledby") ||
          svg.getAttribute("role") === "img"
        ) {
          return;
        }

        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
        svg.setAttribute("aria-label", `icona-${crypto.randomUUID()}`);
      });
    };

    mark();
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) mark(node);
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);
};

const App = () => {
  useDecorativeSvgIcons();
  return (
    <Provider
      store={createAdminStore({
        authProvider,
        dataProvider: dp,
        history,
      })}
    >
      <AuthContext.Provider value={authProvider}>
        <DataProviderContext.Provider value={dp}>
          <SettingsWrapper />
        </DataProviderContext.Provider>
      </AuthContext.Provider>
    </Provider>
  );
};

export default withContext({}, () => ({}))(App);
